import { render, staticRenderFns } from "./profileTakeAssent.vue?vue&type=template&id=14de4b80&"
import script from "./profileTakeAssent.vue?vue&type=script&lang=js&"
export * from "./profileTakeAssent.vue?vue&type=script&lang=js&"
import style0 from "./profileTakeAssent.vue?vue&type=style&index=0&id=14de4b80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports